<div class="container" *ngIf="this.isAuthenticated; else other">
  <div class="navigation">
    <app-navigation></app-navigation>
  </div>

  <div class="header">
    <app-header></app-header>
  </div>

  <div class="main">
    <router-outlet></router-outlet>
  </div>
</div>

<ng-template #other>
  <router-outlet></router-outlet>
</ng-template>